import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class OnboardingStepPayloadService {
  public compactStepData(stepData: Record<string, unknown>): Record<string, unknown> {
    const compacted = this.omitNilDeep(stepData);
    if (compacted === undefined || compacted === null || typeof compacted !== 'object' || Array.isArray(compacted)) {
      return {};
    }
    return compacted as Record<string, unknown>;
  }

  private omitNilDeep(value: unknown): unknown {
    if (value === null || value === undefined) {
      return undefined;
    }
    if (Array.isArray(value)) {
      return value.map((item: unknown) => this.omitNilDeep(item));
    }
    if (typeof value === 'object') {
      const record = value as Record<string, unknown>;
      const result: Record<string, unknown> = {};
      for (const key of Object.keys(record)) {
        const cleaned = this.omitNilDeep(record[key]);
        if (cleaned !== undefined && cleaned !== null) {
          result[key] = cleaned;
        }
      }
      return result;
    }
    return value;
  }
}
